import { render, staticRenderFns } from "./Archive.vue?vue&type=template&id=5d642560&scoped=true"
import script from "./Archive.vue?vue&type=script&lang=js"
export * from "./Archive.vue?vue&type=script&lang=js"
import style0 from "./Archive.vue?vue&type=style&index=0&id=5d642560&prod&lang=scss&scoped=true"
import style1 from "./Archive.vue?vue&type=style&index=1&id=5d642560&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d642560",
  null
  
)

export default component.exports